import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
    @Output() pageChange = new EventEmitter<number>();

    @Input() totalPages: number;
    @Input() currentPage: number;

    pages: number[] = [];
    firstPart: number[] = [];
    lastPart: number[] = [];

    constructor() {}

    ngOnInit() {
        // @ts-ignore-start: не используемый параметр "e"
        this.pages = new Array(this.totalPages).fill(0).map((e, i) => i + 1);
        // @ts-ignore-end
        if (this.currentPage > 1 && this.currentPage < 5) {
            this.firstPart = this.pages.slice(0, this.currentPage - 1);
        } else {
            this.firstPart = this.pages.slice(this.currentPage - 4, this.currentPage - 1);
        }
        this.lastPart = this.pages.slice(this.currentPage, this.currentPage + 3);
    }

    get showPreviousPage(): boolean {
        return this.currentPage > 0 && this.totalPages > 1;
    }

    get showNextPage(): boolean {
        return this.currentPage + 1 < this.totalPages && this.totalPages > 1;
    }

    goToPage(page: number): void {
        this.pageChange.next(page);
        this.currentPage = page;
        this.ngOnInit();
    }

    clickNext(): void {
        if (this.showNextPage) {
            this.goToPage(this.currentPage + 1);
        }
    }

    clickPrevious(): void {
        if (this.showPreviousPage) {
            this.goToPage(this.currentPage - 1);
        }
    }
}
